import { FormLabel as BaseLabel, FormLabelProps } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import React, { FC } from 'react';

// Helpers
import { mq } from 'styles/breakpoints';
import { rem } from 'utils/fonts';

const StyledLabel = styled(BaseLabel)`
  padding-bottom: 13px;
  font-size: ${rem(14)};
  font-weight: normal;

  ${mq.md} {
    padding-bottom: 15px;
    font-size: ${rem(16)};
  }
`;

const Label: FC<FormLabelProps> = ({ children, ...props }) => {
  return (
    <StyledLabel color="gray.400" m="0px" {...props}>
      {children}
    </StyledLabel>
  );
};

export default Label;
